import { inject } from '@angular/core';
import { Router, type CanMatchFn } from '@angular/router';
import { map, of, switchMap } from 'rxjs';
import type { Role } from '../models/auth.model';
import { AuthService } from '../services/auth.service';

export function roleGuard(allowed: Role[]): CanMatchFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    // If user is already authenticated, check role immediately
    if (auth.isAuthenticated()) {
      const role = auth.role();
      if (role === 'SUPER_ADMIN') return true;
      if (role && allowed.includes(role)) return true;
      return router.createUrlTree(['/forbidden']);
    }

    // If we have a token but no user yet, wait for bootstrap to complete
    if (auth.hasAccessToken()) {
      return auth.bootstrap().pipe(
        map((user) => {
          if (!user) {
            return router.createUrlTree(['/login']);
          }
          const role = auth.role();
          if (role === 'SUPER_ADMIN') return true;
          if (role && allowed.includes(role)) return true;
          return router.createUrlTree(['/forbidden']);
        }),
      );
    }

    // No token, redirect to login
    return router.createUrlTree(['/login']);
  };
}
